import { AxiosInstance } from 'axios';
import { createContextAwareHandlers } from './instance';

export const getAllUsers = (instance: AxiosInstance) => async (customerId: string): Promise<CustomerUser[]> => {
  const { data } = await instance.get<CustomerUser[]>(`/customers/${customerId}/users`);

  return data;
};

export const createUserInvite = (instance: AxiosInstance) => async (customerId: string, payload: UserPayload): Promise<InvitationResponse> => {
  const { data } = await instance.post<InvitationResponse>(`/customers/${customerId}/users`, payload);

  return data;
};

export const updateUser = (instance: AxiosInstance) => async (customerId: string, payload: UserPayload, userId: string): Promise<void> => {
  await instance.put<CustomerUser>(`/customers/${customerId}/users/${userId}`, payload);
};

export const deleteUser = (instance: AxiosInstance) => async (customerId: string, userId: string): Promise<void> => {
  await instance.delete<CustomerUser>(`/customers/${customerId}/users/${userId}`);
};

export const getUserSeats = (instance: AxiosInstance) => async (customerId: string): Promise<Seats> => {
  const { data } = await instance.get<Seats>(`/customers/${customerId}/seats`);

  return data;
};

export const getRoles = (instance: AxiosInstance) => async (customerId: string): Promise<Roles> => {
  const { data } = await instance.get<Roles>(`/customers/${customerId}/authorization`);

  return data;
};

const handlers = {
  getAllUsers,
  createUserInvite,
  updateUser,
  deleteUser,
  getUserSeats,
  getRoles,
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createAllUsersApi = (context: PortalContext) => {
  return createContextAwareHandlers(context, handlers);
};

export default createAllUsersApi;
